<template></template>

<script>
const apiUrl = 'https://www.chim.org.cn',
      loginUrl = '/personal/login';
export default {
  apiUrl,
  loginUrl,
  methods:{
    init(){
      const apiUrl = '11';
    }
  },
  created() {
    this.init()
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Global/global.vue